import React from 'react';

import './style.scss';

const Instagram = ({ profile, image, account, datestamp, link }) => (
  <div className="square shadowed">
    <div className="image" />
    <div className="content ocean-beach-border">
      <a href="https://www.instagram.com/fiferries" target="_blank" rel="noopener noreferrer"><img className="profile shadowed" src={profile} alt="@fiferries" /></a>
      <a href={link} target="_blank" rel="noopener noreferrer"><h2>@{account}</h2></a>
      <p className="timestamp">{datestamp}</p>
    </div>
    <div className="background" style={{ backgroundImage: `url(${image})` }} />
  </div>
);

export default Instagram;
 